const Unauthorized = () => {
  return <h2>Unauthorized - You do not have access to this page</h2>;
};

export default Unauthorized;
